import P2Regular from 'components/typography/P2Regular';
import { MeasuringDeviceRow } from 'components/tables/data/measuring-device/types';

/**
 * Column for the type.
 */
export default function TypeColumn({ data: { type } }: { data: MeasuringDeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {type}
    </P2Regular>
  );
}
